import { IFileModel } from "@shared/filegroup/data-access";

export type THotsiteConfiguration = {
    Address: string;
    BackgroundFile: IFileModel;
    Url: string;
    Email: string;
    Latitude: string;
    Longitude: string;
    Phone: string;
    TenantId: string;
    Terms?: string;
}

export type THotsitePlanCycle = {
    PlanCycleId?: string;
    HotsitePlanId?: string;
    PlanId?: string;
    CycleId?: string;
    Name?: string;
    OldValue?: string;
    Order?: number;
    DisplayName?: string;
}

export type THotsitePlan = {
    HotsitePlanId?: string;
    HotsiteId?: string;
    DisplayAccessTime?: string;
    PlanId?: string;
    Name?: string;
    Position?: number;
    CardUniqueCycle?: boolean;
    CardUniqueAccessTime?: boolean;
    RemoveGradient?: boolean;
    ShowTotal?: boolean;
    BorderColorRecommended?: string;
    Hotsite?: any;
    Cycles?: THotsitePlanCycle[];
    DisplayStartOn?: string;
    AccessesTimes?: THotsitePlanAccessTime[];
    BackgroundFile?: IFileModel;
    StartOn?: string;
}

export type THotsite = {
    AllowFacialIdCapture?: boolean;
    AskForAddress?: boolean;
    AskForResponsible?: boolean;
    DisableCheckout?: boolean;
    HideNotification?: boolean;
    HotsiteId?: string;
    IsActive?: boolean;
    IsDefault?: boolean;
    HotsiteType?: eTypeHotsite;
    FontType?: number;
    ImageType?: number;
    Name?: string;
    Description?: string;
    Path?: string;
    SuccessTitle?: string;
    SuccessMessage?: string;
    LeadTitle?: string;
    LeadDescription?: string;
    Color?: string;
    ThemeColor?: number;
    ThemeColorPrimary?: string;
    ThemeColorSecondary?: string;
    BackgroundFile?: IFileModel;
    Plans?: THotsitePlan[];
    TenantId?: string;
    AddedBy?: string;
    UpdatedBy?: string;
    AddedOn?: string;
    UpdatedOn?: string;
    MarketingStartOn?: string;
    MarketingEndOn?: string;
}

export type THotsitePlanAccessTime = {
    PlanAccessTimeId?: string;
    HotsitePlanId?: string;
    PlanId?: string;
    AccessTimeId?: string;
    DisplayName?: string;
}
    
export enum eImageType
{
    Image,
    ColorSolid
}

export enum eTypeHotsite {
    Contact = 0,
    Offer = 1,
    Register = 2,
}

export enum eHotsiteColorScheme {
    PurplePink = 1,
    BlueCyan = 2,
    TealNeon = 3,
    OrangeBlack = 4,
    YellowBlack = 5,
    RedBlack = 6,
    CyanGreen = 7,
}

export enum eHotsiteFontType {
    OpenSans = 1,
    Merriweather = 2,
    PatrickHand = 3,
}

export const hotsiteFonts = [
    {
      id: eHotsiteFontType.OpenSans,
      fontToken: 'font-open-sans',
      fontName: 'Open Sans',
    },
    {
      id: eHotsiteFontType.Merriweather,
      fontToken: 'font-merriweather',
      fontName: 'Merriweather',
    },
    {
      id: eHotsiteFontType.PatrickHand,
      fontToken: 'font-patrick-hand',
      fontName: 'Patrick Hand',
    },
];

export const hotsiteColorScheme = [
    {
        id: eHotsiteColorScheme.PurplePink,
        name: 'HOTSITE.FORM.COLORS.PURPLE_PINK',
        color1: '#430e67',
        color2: '#ff1b61',
    },
    {
        id: eHotsiteColorScheme.BlueCyan,
        name: 'HOTSITE.FORM.COLORS.BLUE_CYAN',
        color1: '#3f4fd5',
        color2: '#00b1ff',
    },
    {
        id: eHotsiteColorScheme.TealNeon,
        name: 'HOTSITE.FORM.COLORS.TEAL_NEON',
        color1: '#007ca8',
        color2: '#00ed66',
    },
    {
        id: eHotsiteColorScheme.OrangeBlack,
        name: 'HOTSITE.FORM.COLORS.ORANGE_BLACK',
        color1: '#f29f05',
        color2: '#191428',
    },
    {
        id: eHotsiteColorScheme.YellowBlack,
        name: 'HOTSITE.FORM.COLORS.YELLOW_BLACK',
        color1: '#d7f205',
        color2: '#0d0d0d',
    },
    {
        id: eHotsiteColorScheme.RedBlack,
        name: 'HOTSITE.FORM.COLORS.RED_BLACK',
        color1: '#8c0303',
        color2: '#0d0d0d',
    },
    {
        id: eHotsiteColorScheme.CyanGreen,
        name: 'HOTSITE.FORM.COLORS.CYAN_GREEN',
        color1: '#05dbf2',
        color2: '#0295a6',
    },
];


export enum EHotsiteIds {
    HOTSITE_CONFIG = 'hotsite-config',
    OFFER_PAGES = 'offer-pages',
    CONTACT_PAGES = 'contact-pages',
    REGISTER_PAGES = 'register-pages',
    TERMS_OF_USE_PAGES = 'terms-of-use-pages',
}

export const hotsitePageFragments = [
    {
      title: 'HOTSITE.PAGE_FRAGMENTS.INFO',
      id: EHotsiteIds.HOTSITE_CONFIG,
    },
    {
      title: 'HOTSITE.PAGE_FRAGMENTS.OFFER_PAGES',
      id: EHotsiteIds.OFFER_PAGES,
    },
    {
      title: 'HOTSITE.PAGE_FRAGMENTS.CONTACT_PAGES',
      id: EHotsiteIds.CONTACT_PAGES,
    },
    {
      title: 'HOTSITE.PAGE_FRAGMENTS.REGISTER_PAGES',
      id: EHotsiteIds.REGISTER_PAGES,
    },
    {
      title: 'HOTSITE.PAGE_FRAGMENTS.TERMS_OF_USE_PAGES',
      id: EHotsiteIds.TERMS_OF_USE_PAGES,
    }
];